@if (photoUrl) {
  <img class="profilePictureImg" [src]="photoUrl" alt="" />
} @else {
  <div class="profilePictureInitials d-flex justify-content-center align-items-center"
      [ngStyle]="{'outline-color': candidate?.status == 'Active' ? '#95D9DA' : (candidate?.status == 'Inactive' ? '#F4845F' : '#e5e5e5'), 'background-color': initialsBgColors[(candidate?.id.toString().slice(-1))]}">
      <span>{{initials}}</span>
  </div>
}
